import { of } from 'rxjs';
import { mockPrintableDocuments } from '@sc/portal.fe.lib.app-components';
var PolicyDocumentsServiceStub = /** @class */ (function () {
    function PolicyDocumentsServiceStub() {
    }
    PolicyDocumentsServiceStub.prototype.getDocuments = function (policyNumber) {
        return of(mockPrintableDocuments(3));
    };
    return PolicyDocumentsServiceStub;
}());
export { PolicyDocumentsServiceStub };
